import { isNotEmptyArray } from '@impuls-coach/util-is';
import { ProgramType, RootStateType } from './programs';

/*
 * Returns the id of the active programs
 * note: currently there is 0 - 1 active programs.in the future there may be 0 - n.
 */
export const getActiveProgramId = (state: RootStateType): string | null => {
	const activeIds = state.programs.allIds;
	if (activeIds.length === 0) {
		return null;
	}

	return state.programs.allIds[activeIds.length - 1]; // get only the newest one;
};
/*
 * Returns the amount of active programs
 */
export const getHasActivePrograms = (state: RootStateType): boolean => {
	return state.programs.allIds.length !== 0;
};
/*
 * Returns if the programs were loaded
 */
export const getHasLoadedActivePrograms = (state: RootStateType): boolean => {
	return state.programs.hasLoadedActivePrograms;
};
/*
 * Returns the amount of active programs
 */
export const getCountActivePrograms = (state: RootStateType): number => {
	return state.programs.allIds.length;
};
/*
 * Returns the active program or null
 */
export const getActiveProgram = (state: RootStateType): ProgramType | null => {
	let activeProgram: ProgramType | null = null;
	if (isNotEmptyArray(state.programs.allIds) && state.programs.byId) {
		const activePrograms = state.programs.allIds
			.filter((programId: string): boolean => {
				const program = (state.programs.byId || {})[programId];
				return program && program.status === 'ACTIVE';
			})
			.map((programId: string) => {
				return (state.programs.byId || {})[programId];
			});

		activeProgram = activePrograms[activePrograms.length - 1]; // get the newest one
	}

	return activeProgram;
};

export const getActiveProgramExternalId = (state: RootStateType): string | null => {
	const activeProgram = getActiveProgram(state);

	return (activeProgram || ({} as any)).externalId || null;
};

export const getActiveProgramName = (): string => {
	return '';
};

/*
 * Returns the number of days in the active playlist
 */
export const getNumberOfDays = (state: RootStateType): number | null => {
	let numberOfDays: null | number = null;

	try {
		const activeProgram = getActiveProgram(state);
		if (activeProgram) {
			numberOfDays = activeProgram.numberOfDays;
		}
	} catch (err) {
		// do nothing
	}

	return numberOfDays;
};

/*
 * Returns today's day number in the active playlist.
 * @param { State } state
 */
export const getProgramTodayDayNumber = (state: RootStateType): number | null => {
	const activeProgram: ProgramType | null = getActiveProgram(state);
	return activeProgram ? activeProgram.todayDayNumber : null;
};

/*
 * Returns if the active program is loading
 */
export const getIsLoadingActivePrograms = (state: RootStateType): boolean | null => {
	return state.programs.isLoadingActivePrograms;
};

export const getIsLoadingManualFinish = (state: RootStateType): boolean | null => {
	return state.programs.isLoadingManualFinish;
};

// tslint:disable-next-line:variable-name
export const __getIsLastDay_DEPRECATED = (state: RootStateType): boolean => {
	const activeProgram = getActiveProgram(state) || ({} as ProgramType);
	return activeProgram.finishProgramButton || false;
};

export const getIsLastDay = (state: RootStateType, currentDayNumber: number): boolean => {
	const activeProgram = getActiveProgram(state) || ({} as ProgramType);
	return activeProgram.numberOfDays - currentDayNumber === 0;
};

export const getFinishProgramData = (state: RootStateType): Object => {
	const activeProgram: ProgramType = getActiveProgram(state) || ({} as any);

	if (__getIsLastDay_DEPRECATED(state)) {
		const hours =
			activeProgram.finishProgramButton &&
			typeof activeProgram.finishProgramButton.hoursUntilFinished !== 'undefined'
				? activeProgram.finishProgramButton.hoursUntilFinished
				: 0;
		const todos =
			activeProgram.finishProgramButton &&
			typeof activeProgram.finishProgramButton.numberOfOpenItems !== 'undefined'
				? activeProgram.finishProgramButton.numberOfOpenItems
				: 0;

		return { hours, todos };
	}

	return {};
};
